/* Sheepskinhouse.com - 11 Year Birthday campaign
   Drives the countdowns and the click-to-copy discount code.
   Safe to load on every page: it does nothing if no birthday markup is present. */
(function () {
  'use strict';

  if (window.__sshBirthday) return;
  window.__sshBirthday = true;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setPart(root, key, value) {
    var node = root.querySelector('[data-bd-' + key + ']');
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-bd-countdown]');
    var now = Date.now();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var end = Date.parse(el.getAttribute('data-bd-countdown'));
      if (isNaN(end)) continue;

      var left = end - now;
      if (left < 0) left = 0;

      setPart(el, 'd', pad(Math.floor(left / 86400000)));
      setPart(el, 'h', pad(Math.floor((left % 86400000) / 3600000)));
      setPart(el, 'm', pad(Math.floor((left % 3600000) / 60000)));
      setPart(el, 's', pad(Math.floor((left % 60000) / 1000)));

      if (left === 0) el.setAttribute('data-bd-ended', 'true');
    }
  }

  function flash(hint) {
    if (!hint || hint.getAttribute('data-bd-busy')) return;
    var original = hint.textContent;
    hint.setAttribute('data-bd-busy', '1');
    hint.textContent = 'Copied';
    setTimeout(function () {
      hint.textContent = original;
      hint.removeAttribute('data-bd-busy');
    }, 1800);
  }

  function legacyCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '-1000px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      /* clipboard is simply unavailable, the code is still on screen */
    }
    document.body.removeChild(field);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-bd-copy]');
    if (!button) return;

    var code = button.getAttribute('data-bd-copy');
    var hint = button.querySelector('[data-bd-copy-hint]');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(
        function () { flash(hint); },
        function () { legacyCopy(code); flash(hint); }
      );
    } else {
      legacyCopy(code);
      flash(hint);
    }
  });

  document.addEventListener('shopify:section:load', tick);

  tick();
  setInterval(tick, 1000);
})();
